export default "<p>\n  custom-tooltip-cells-cartera works!\n</p>\n";